export default __webpack_public_path__ + "media/images/supplied/mowerSlider-21b00e214f3498c71614854e7388f24f.jpg";